"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseComparisonCondition = void 0;
const has_js_1 = require("../../../../../utils/has.js");
const types_js_1 = require("./types.js");
const comparisonOperatorExpression = {
    eq: '=',
    ne: '<>',
    gt: '>',
    gte: '>=',
    lt: '<',
    lte: '<='
};
const parseComparisonCondition = (conditionParser, condition) => {
    var _a;
    let attributePath;
    let transform;
    const size = (0, has_js_1.has)(condition, 'size');
    if (size) {
        attributePath = condition.size;
        transform = false;
    }
    else {
        attributePath = condition.attr;
        transform = (_a = condition.transform) !== null && _a !== void 0 ? _a : true;
    }
    const comparisonOperator = Object.keys(condition).find(types_js_1.isComparisonOperator);
    const expressionAttributeValue = condition[comparisonOperator];
    conditionParser.resetExpression();
    const attribute = conditionParser.appendAttributePath(attributePath, { size });
    conditionParser.appendToExpression(` ${comparisonOperatorExpression[comparisonOperator]} `);
    conditionParser.appendAttributeValueOrPath(attribute, expressionAttributeValue, { transform });
};
exports.parseComparisonCondition = parseComparisonCondition;
